module.exports = __webpack_public_path__ + "static/media/v-01.6c7d9dc8.png";